import { connect } from 'react-redux'

import { selectConversationsAssignedCreatedRatioGauge } from 'ducks/reports/gauges'

import { PercentGauge } from 'ducks/reports/visualizations'

const staticSelect = {
  height: 300,
  scale: { y: 'percent' },
  title: 'Assigned Conversations',
}
const select = (state, props) => ({
  ...staticSelect,
  gauge: selectConversationsAssignedCreatedRatioGauge(state, props),
})
export default connect(select)(PercentGauge)
